import { environment } from "../../../../environments/environment";

/**
 * Protected resources configuration
 * Maps API endpoints to their required scopes
 */
export interface ProtectedResource {
    endpoint: string;
    scopes: string[];
}

//Automatically attach access tokens to outgoing HTTP requests
export const protectedResources: Record<string, ProtectedResource> = {
    api: {
        endpoint: environment.api.baseUrl,
        scopes: environment.api.scopes,
    }  
};

/**
 * Creates a Map for MSAL Interceptor configuration
 */
export function getProtectedResourcesMap(): Map<string, string[]> {
    const protectedResourceMap = new Map<string, string[]>();

    // Add your API endpoints with wildcards
    protectedResourceMap.set(`${environment.api.baseUrl}/*`, protectedResources['api'].scopes);   

    return protectedResourceMap;
}